import { atom, selector } from 'recoil';

import { recoilPersist } from 'recoil-persist';
/*
{
    userId: '',
    userName: '',
    siteNumber: '',
    loginType: '',
    memberNumber: '',
}
 */
const { persistAtom } = recoilPersist({
  storage: sessionStorage,
});
export const userInfoState = atom({
  key: 'memberInfoState',
  default: null,
  effects_UNSTABLE: [persistAtom],
});

export const isManagerValue = selector({
  key: 'isManagerValue',
  get: ({ get }) => {
    const userInfo = get(userInfoState);
    return userInfo && process.env.REACT_APP_JOB_GROUP_MGR.split(',').includes(userInfo.jobGroupNumber);
  },
});
